import type { MainSliderButton } from './types';

export const cn = (...classes: Array<string | false | null | undefined>) =>
  classes.filter(Boolean).join(' ');

export const getButtons = (
  buttons?: MainSliderButton[],
  button?: MainSliderButton,
) => {
  return buttons ?? (button ? [button] : []);
};
